import { motion } from "framer-motion";
import type React from "react";
import { useState } from "react";
import type { VirtuosoProps } from "react-virtuoso";
import { GroupedVirtuoso, Virtuoso } from "react-virtuoso";

// This is only to make sure we have all components in one place
// Don't know if it's a good thing..
const VirtualizedList = Virtuoso;
const VirtualizedList_Grouped = GroupedVirtuoso;

// Workaround for the fact that virtuoso doesn't support shrinkable containers
// and we need to set the height of the container manually
// https://github.com/petyosi/react-virtuoso/issues/652
// https://github.com/petyosi/react-virtuoso/discussions/447
const VirtualizedList_WithShrinkableContainer = <
    ItemData = unknown,
    Context = unknown,
>(
    props: {
        disableHeightAnimation?: boolean;
        minHeight?: React.CSSProperties["minHeight"];
        maxHeight: React.CSSProperties["maxHeight"];
        containerClassName?: string;
    } & VirtuosoProps<ItemData, Context>,
) => {
    const [height, setHeight] = useState(0);
    const { minHeight, maxHeight, containerClassName, ...virtuosoProps } =
        props;
    return (
        <motion.div
            initial={{ height: 0 }}
            animate={{ height }}
            transition={{
                type: "tween",
                ease: "easeInOut",
                duration: props.disableHeightAnimation ? 0 : 0.2,
            }}
            style={{
                overflow: "hidden",
                transformOrigin: "top",
                height,
                minHeight,
                maxHeight,
            }}
            className={containerClassName}>
            <Virtuoso {...virtuosoProps} totalListHeightChanged={setHeight} />
        </motion.div>
    );
};

export {
    VirtualizedList,
    VirtualizedList_Grouped,
    VirtualizedList_WithShrinkableContainer,
};
